import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import css from './FieldToggleSwitch.module.css';

const FieldToggleSwitchComponent = props => {
  const {
    className,
    rootClassName,
    id,
    label,
    input,
    meta,
    leftLabel,
    rightLabel
  } = props;

  const { name, onBlur, onChange, onFocus, value, ...restInput } = input;
  const { touched, error } = meta;

  const classes = classNames(rootClassName || css.root, className);
  const toggleId = id || name;

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={toggleId} className={css.label}>
          {label}
        </label>
      )}
      <div className={css.toggleContainer}>
        {leftLabel && <span className={css.toggleLabel}>{leftLabel}</span>}
        <label className={css.switch}>
          <input
            {...restInput}
            id={toggleId}
            name={name}
            type="checkbox"
            checked={value || false}
            onBlur={onBlur}
            onChange={e => onChange(e.target.checked)}
            onFocus={onFocus}
          />
          <span className={classNames(css.slider, css.round)}></span>
        </label>
        {rightLabel && <span className={css.toggleLabel}>{rightLabel}</span>}
      </div>
      {touched && error && <span className={css.error}>{error}</span>}
    </div>
  );
};

const FieldToggleSwitch = props => {
  return <Field component={FieldToggleSwitchComponent} {...props} />;
};

export default FieldToggleSwitch;
